export default __webpack_public_path__ + "static/media/available-for-pickup.b1cbef98.svg";